export type WebcamFilterOption = {
  value: string;
  label: string;
  keywords?: string[];
};

export type WebcamFilterGroup = {
  id: string;
  label: string;
  options: WebcamFilterOption[];
};

export const webcamFilterGroups: WebcamFilterGroup[] = [
  {
    id: 'brand',
    label: 'Thương hiệu',
    options: [
      { value: 'logitech', label: 'Logitech', keywords: ['logitech'] },
      { value: 'razer', label: 'Razer', keywords: ['razer'] },
      { value: 'hikvision', label: 'HIKVISION', keywords: ['hikvision'] },
      { value: 'dahua', label: 'Dahua', keywords: ['dahua'] },
      { value: 'rapoo', label: 'Rapoo', keywords: ['rapoo'] },
      { value: 'asus', label: 'ASUS', keywords: ['asus'] },
    ],
  },
  {
    id: 'resolution',
    label: 'Độ phân giải',
    options: [
      { value: '720p', label: 'HD 720p', keywords: ['720p', 'hd 720'] },
      { value: '1080p', label: 'Full HD 1080p', keywords: ['1080p', 'full hd'] },
      { value: '2k', label: '2K', keywords: ['2k', '1440p'] },
      { value: '4k', label: '4K Ultra HD', keywords: ['4k', 'ultra hd'] },
    ],
  },
  {
    id: 'features',
    label: 'Tính năng',
    options: [
      { value: 'mic', label: 'Tích hợp Microphone', keywords: ['mic', 'micro', 'dam thoai'] },
      { value: 'autofocus', label: 'Tự động lấy nét', keywords: ['autofocus', 'lay net tu dong'] },
      { value: 'ring-light', label: 'Có đèn Ring Light', keywords: ['ring light', 'den led'] },
      { value: 'privacy-cover', label: 'Nắp che riêng tư', keywords: ['privacy cover', 'nap che'] },
    ],
  },
];
